import axios from "axios";

axios.defaults.baseURL = "https://uzchange.investup.uz/api";

const token = localStorage.getItem('token');

axios.defaults.headers.common = {
  Authorization: `Bearer ${token}`,
  Accept: 'application/json'
};
